import React from "react";
import { withStyles } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/KeyboardArrowLeft";
import ChartComponent from "./ChartComponent";
import { RMAXLogger } from "../../../../../services/LoggerService/RMAXLogger";

const styles = (theme) => ({
  container: {
    boxSizing: "border-box",
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    height: "100%",
    "& *": {
      boxSizing: "border-box",
    },
  },
  header: {
    color: theme.TextColor,
    display: "flex",
    padding: "4px 0",
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontSize: theme.headerTextFontSize,
    textAlign: "center",
    lineHeight: "21px",
    fontWeight: "bold",
  },
  backButton: {
    color: theme.gridTextColor,
    cursor: "pointer",
  },

  backIcon: {
    verticalAlign: "middle",
    fontSize: "25px",
  },
  layoutTitle: {
    color: theme.HeaderSelectedText,
    display: "flex",
    justifyContent: "flex-end",
    width: "90%",
  },
});

const RouteChart = props => {
  const {classes} = props;
  const chartOpened = {planDate: props?.planDate, chartTitle: props.chartConfig?.title, selectedModule: props?.checked }
  RMAXLogger.info("KPIReportInsight", chartOpened);
  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <div className={classes.backButton} onClick={props.goBack}>
          <ArrowBackIcon classes={{ root: classes.backIcon }} /> Back
        </div>
        <div className={classes.layoutTitle}>
          Plan Date : {props.planDate}, Terminal : {props.terminal}
        </div>
      </header>
      <div>
        <ChartComponent
          data={props.data}
          checked={props.checked}
          chartConfig={props.chartConfig}
          classes={props.indexClasses}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(RouteChart);